import { useState } from 'preact/hooks'
import { deleteDocuments } from '@/services/api'
import { getProcessId } from '@/services/session'

interface UseDeleteDocumentReturn {
  deleteDocument: (documentId: string) => Promise<void>
  deleteMultipleDocuments: (documentIds: string[]) => Promise<void>
  isDeleting: boolean
  error: string | null
}

export function useDeleteDocument(): UseDeleteDocumentReturn {
  const [isDeleting, setIsDeleting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const deleteDocument = async (documentId: string) => {
    const processId = getProcessId()
    if (!processId) {
      setError('Brak ID procesu')
      throw new Error('No process ID available')
    }

    setIsDeleting(true)
    setError(null)

    await deleteDocuments(
      {
        processId,
        documentIds: [documentId],
      },
      {
        onSuccess: () => {
          setIsDeleting(false)
        },
        onError: err => {
          const errObj = err as unknown as {
            response?: { data?: { detail?: string } }
            message?: string
          }
          const errorMessage =
            errObj.response?.data?.detail ??
            errObj.message ??
            'Błąd usuwania dokumentu'
          setError(errorMessage)
          setIsDeleting(false)
        },
      }
    )
  }

  const deleteMultipleDocuments = async (documentIds: string[]) => {
    const processId = getProcessId()
    if (!processId) {
      setError('Brak ID procesu')
      throw new Error('No process ID available')
    }

    if (documentIds.length === 0) {
      return
    }

    setIsDeleting(true)
    setError(null)

    await deleteDocuments(
      {
        processId,
        documentIds,
      },
      {
        onSuccess: () => {
          setIsDeleting(false)
        },
        onError: err => {
          const errObj = err as unknown as {
            response?: { data?: { detail?: string } }
            message?: string
          }
          const errorMessage =
            errObj.response?.data?.detail ??
            errObj.message ??
            'Błąd usuwania dokumentów'
          setError(errorMessage)
          setIsDeleting(false)
        },
      }
    )
  }

  return {
    deleteDocument,
    deleteMultipleDocuments,
    isDeleting,
    error,
  }
}
